import RecruiterList from './Container';

export default RecruiterList;